import { render, staticRenderFns } from "./rate-card.vue?vue&type=template&id=08ad17c7&scoped=true"
import script from "./rate-card.vue?vue&type=script&lang=js"
export * from "./rate-card.vue?vue&type=script&lang=js"
import style0 from "./rate-card.vue?vue&type=style&index=0&id=08ad17c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ad17c7",
  null
  
)

export default component.exports